import { GroupIdAndType } from '@common/state/modules/mediaDetails';
import { ClusterItemGroup } from '@common/state/modules/mediaDetails/models';
import { ClusterMapItem } from '@common/web-worker';

export interface ClusterGroupIds {
  clusterId: string | undefined;
  udrGroupIds: string[];
  detectionGroups: GroupIdAndType[];
  isMergedGroup: boolean;
}

// find all the groups assigned to same cluster as provided groupId
export const findClusterGroupIds = (
  clusterMap: { [clusterId: string]: ClusterMapItem },
  udrClusterGroups: { [groupId: string]: ClusterItemGroup },
  detectionClusterGroups: { [groupId: string]: ClusterItemGroup },
  groupId: string | undefined
) => {
  let udrGroupIds: string[] = [];
  let detectionGroups: GroupIdAndType[] = [];

  let clusterId;

  if (groupId) {
    let group;
    if (udrClusterGroups) {
      // CTODO extra check because unit test not provided valid type src/redact-app/components/Timeline/Timelines/index.tsx

      group = udrClusterGroups[groupId];
      if (group) {
        udrGroupIds.push(groupId);
      }
    }
    if (!group && detectionClusterGroups) {
      group = detectionClusterGroups[groupId];
      if (group) {
        detectionGroups.push({ id: group.id, type: group.type });
      }
    }
    clusterId = group?.clusterId;
  }

  const clusterMapItem = clusterId ? clusterMap[clusterId] : undefined;
  if (clusterMapItem) {
    udrGroupIds = clusterMapItem.udrGroupIds;

    detectionGroups = [];
    (clusterMapItem.detectionGroupIds || []).forEach((groupId) => {
      const group = detectionClusterGroups[groupId];
      if (group) {
        // if group missing something is wrong
        detectionGroups.push({ id: group.id, type: group.type });
      }
    });
  }
  const totalGroups = udrGroupIds.length + detectionGroups.length;
  const isMergedGroup = totalGroups > 1;

  return {
    clusterId,
    udrGroupIds,
    detectionGroups,
    isMergedGroup,
  };
};

/*
// find all the groups assigned to same cluster as provided groupId
// this is the older version that had to search through all groups 
export const findClusterGroupIdsOld = (
  udrClusterGroups: { [groupId: string]: ClusterItemGroup },
  detectionClusterGroups: { [groupId: string]: ClusterItemGroup },
  groupId: string | undefined
) => {
  let clusterId;
  if (groupId) {
    let group;
    if (udrClusterGroups) {

      group = udrClusterGroups[groupId];
    }
    if (!group && detectionClusterGroups) {
      group = detectionClusterGroups[groupId];
    }
    clusterId = group?.clusterId;
  }

  const udrGroupIds: string[] = [];
  const detectionGroups: GroupIdAndType[] = [];

  if (clusterId) {
    Object.values(udrClusterGroups).forEach((group) => {
      if (group.clusterId === clusterId) {
        udrGroupIds.push(group.id);
      }
    });

    Object.values(detectionClusterGroups).forEach((group) => {
      if (group.clusterId === clusterId) {
        detectionGroups.push({ id: group.id, type: group.type });
      }
    });
  }

  const totalGroups = udrGroupIds.length + detectionGroups.length;
  const isMergedGroup = totalGroups > 1;

  return {
    clusterId,
    udrGroupIds,
    detectionGroups,
    isMergedGroup,
  };
};
*/
